module.exports = __webpack_public_path__ + "img/about-us-leader-bg.598390d8.jpg";